<template>
  <main>
    <div class="tab-content">
      <!-- 資料呈現區塊 -->
      <div class="row" v-if="!editMode">
        <div class="col-12">
          <div class="radio radio-inline">
            <input type="radio" v-model="searchType" id="search-type-1" value="1" />
            <label for="search-type-1">設定中</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" v-model="searchType" id="search-type-2" value="2" />
            <label for="search-type-2">已解除</label>
          </div>
          <hr />
          <!-- Search Block-->
          <table id="searchBlock">
            <thead>
              <tr>
                <th width="30%">
                  <select
                    :id="`param-type`"
                    :data-vv-name="`param-type`"
                    v-validate="'required'"
                    data-vv-as="查詢條件"
                    data-vv-scope="IDs"
                    class="form-control select-width"
                    v-model="selectKey"
                    :class="{ 'is-invalid': errors.has('IDs.param-type') }"
                  >
                    <option value>請選擇</option>
                    <option v-for="(key, value, index) in selectOption" :key="`param-type-${index}`" :value="value">
                      {{ key }}
                    </option>
                  </select>
                </th>
                <td>
                  <input
                    type="text"
                    :id="`search-param`"
                    :data-vv-name="`search-param`"
                    v-validate="'required'"
                    data-vv-as="查詢條件"
                    data-vv-scope="IDs"
                    placeholder="請輸入查詢內容"
                    class="form-control"
                    v-model="selectVal"
                    alt="ch"
                    :class="{ 'is-invalid': errors.has('IDs.search-param') }"
                  />
                </td>
                <td>
                  <a class="btn btn-primary" @click="doQuery('val')">查詢</a>
                </td>
              </tr>
              <tr>
                <th width="30%">異動日期</th>
                <td class="text-center">
                  <select
                    :id="`start-date-year`"
                    :data-vv-name="`start-date-year`"
                    v-validate="'required'"
                    data-vv-as="異動日期(起)"
                    data-vv-scope="Dates"
                    class="form-control form-control-inline"
                    v-model="start_date[0]"
                    :class="{ 'is-invalid': errors.has('Dates.start-date-year') }"
                  >
                    <option v-for="(opt, y_opt_i) in yearOpt" :key="`start-year-${y_opt_i}`" :value="opt">
                      {{ opt - 1911 }}年
                    </option>
                  </select>
                  <span class="text">/</span>
                  <select
                    :id="`start-date-month`"
                    :data-vv-name="`start-date-month`"
                    v-validate="'required'"
                    data-vv-as="異動日期(起)"
                    data-vv-scope="Dates"
                    class="form-control form-control-inline mr-2"
                    v-model="start_date[1]"
                    :class="{ 'is-invalid': errors.has('Dates.start-date-month') }"
                  >
                    <option v-for="(opt, m_opt_i) in monthOpt" :key="`start-month-${m_opt_i}`" :value="opt">
                      {{ opt }}月
                    </option>
                  </select>

                  <span class="mr-2">~</span>

                  <select
                    :id="`end-date-year`"
                    :data-vv-name="`end-date-year`"
                    v-validate="'required'"
                    data-vv-as="異動日期(訖)"
                    data-vv-scope="Dates"
                    class="form-control form-control-inline"
                    v-model="end_date[0]"
                    :class="{ 'is-invalid': errors.has('Dates.end-date-year') }"
                  >
                    <option v-for="(opt, y_opt_i) in yearOpt" :key="`end-year-${y_opt_i}`" :value="opt">
                      {{ opt - 1911 }}年
                    </option>
                  </select>
                  <span class="text">/</span>
                  <select
                    :id="`end-date-month`"
                    :data-vv-name="`end-date-month`"
                    v-validate="'required'"
                    data-vv-as="異動日期(訖)"
                    data-vv-scope="Dates"
                    class="form-control form-control-inline mr-1"
                    v-model="end_date[1]"
                    :class="{ 'is-invalid': errors.has('Dates.end-date-month') }"
                  >
                    <option v-for="(opt, m_opt_i) in monthOpt" :key="`end-month-${m_opt_i}`" :value="opt">
                      {{ opt }}月
                    </option>
                  </select>
                </td>
                <td>
                  <a class="btn btn-primary" @click="doQuery()">查詢</a>
                </td>
              </tr>
            </thead>
          </table>
          <br />
          <!-- 資料呈現區塊 -->
          <table id="bullentin_datatable" class="table datatable table-striped area-list-datatable">
            <thead>
              <tr>
                <th>#</th>
                <th
                  id="col_FORM_NO"
                  :class="
                    'sorting ' + (order.fieldName == 'form_no' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('form_no')"
                  class="text-center"
                >
                  簡覆表編號
                </th>
                <th
                  id="col_AGNT_ID"
                  :class="
                    'sorting ' + (order.fieldName == 'agnt_id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('agnt_id')"
                  class="text-center"
                >
                  業務員
                </th>
                <th
                  id="col_ID"
                  :class="'sorting ' + (order.fieldName == 'id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="processList('id')"
                  class="text-center"
                >
                  客戶
                </th>
                <th
                  id="col_IN_DATE"
                  :class="
                    'sorting ' + (order.fieldName == 'in_date' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('in_date')"
                  class="text-center"
                >
                  {{ searchType == '1' ? '申請日期' : '設定日期' }}
                </th>
                <th
                  id="col_UPD_ID"
                  :class="
                    'sorting ' + (order.fieldName == 'upd_id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('upd_id')"
                  class="text-center"
                >
                  設定人員
                </th>
                <th 
                  id="col_REASON"
                  class="text-center"
                >原因</th>
                <th
                  id="col_SCOPE"
                  :class="
                    'sorting ' + (order.fieldName == 'in_type' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')
                  "
                  @click="processList('in_type')"
                  class="text-center"
                >
                  設定範圍
                </th>
                <th id="col_function" ref="lastCol" class="text-center">功能</th>
              </tr>
            </thead>
            <tbody id="permission-view" v-if="rtnList.length > 0">
              <tr v-for="(item, index) in rtnList" :key="`td-rtnList-${index}`">
                <td>{{ index + 1 }}</td>
                <td>{{ item.form_no }}</td>
                <template v-if="item.agnt_id === ''">
                  <td class="text-center">--</td>
                </template>
                <template v-else>
                  <td class="text-center">
                    <Tooltip
                          :position="index < 3 ? 'bottom' : 'top'"
                          expand_col1="業務員"
                          :expand_col1_value="item.agnt_name"
                          expand_col2="業務員ID"
                          :expand_col2_value="item.agnt_id"
                          expand_col3="客戶"
                          :expand_col3_value="item.id"
                          expand_col4="設定人員" 
                          :expand_col4_value="item.upd_name"                  
                      >
                      {{ item.agnt_name | getMaskName}}<br/>{{ item.agnt_id | getMaskID}}
                      </Tooltip>
                  </td>
                </template>
                <td class="text-center">{{ item.id | getMaskID}}</td>
                <td class="text-center">
                  <div class="date">{{ item.in_date | dateFormat }}</div>
                </td>
                <td class="text-center">{{ item.upd_name | getMaskName}}</td>
                <td>{{ item.memo }}</td>
                <template v-if="item.in_type === '1'">
                  <td class="text-center">特定業務員</td>
                </template>
                <template v-else>
                  <td class="text-center">全部業務員</td>
                </template>
                <template v-if="searchType === '1'">
                  <td :width="iPadWidth" class="text-center">
                    <a class="text-green text-underline pointer-cursor" @click="doEdit(item)">解除</a>
                  </td>
                </template>
                <template v-else>
                  <td :width="iPadWidth" class="text-center">
                    <a class="text-green text-underline pointer-cursor" @click="doPreview(item)">解除紀錄</a>
                  </td>
                </template>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="8" class="empty">
                  <h3 class="text-center py-5">無任何資料</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 資料編輯區塊 -->
      <cust-data-view-permission-content
        :isEdit="editMode"
        :permissionInfo="editData"
        :selectKey="selectKey"
        @doCancelEdit="doCancelEdit"
        @doQuery="doQuery"
      />
    </div>

    <!-- 解除紀錄視窗 -->
    <cust-data-view-permission-modal
      :open="modalOpen"
      :permissionInfo="editData"
      @close="panelClose('modalOpen')"
    />

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";

//component
import mxMask from "@/desktop/components/mxMask";
import CustDataViewPermissionContent from "@/desktop/views/backend/CustDataViewPermissionContent";
import CustDataViewPermissionModal from "@/desktop/views/backend/CustDataViewPermissionModal";
import Tooltip from "@/desktop/components/ToolTip";

//service
import { queryCustDataViewPermission } from "@/service";
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "CustDataViewPermissionEdit",
  mixins: [commonMixin],
  components: {
    CustDataViewPermissionContent,
    CustDataViewPermissionModal,
    mxMask,
    Tooltip
  },
  data() {
    return {
      searchType: "1",
      mxMaskOpen: false,
      start_date: [this.moment().year(), this.moment().month() + 1],
      end_date: [this.moment().year(), this.moment().month() + 1],
      yearOpt: [],
      selectOption: {
        form_no: "簡覆表編號",
        id: "客戶ID",
        form_agnt_id: "業務員ID",
        upd_id: "設定人員",
      },
      selectKey: "",
      selectVal: "",
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      rtnList: [], //顯示資料
      order: {
        fieldName: "subject",
        asc: true,
      },
      iPadWidth: 364,
      editData: {},
      editMode: false,
      modalOpen: false,
    };
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"]),
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //欄位排序
    processList(fieldName) {
      let order = this.order;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "in_date":
          setTimeout(() => {
            this.rtnList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.rtnList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        const ar = a[property] ? a[property] : "";
        const br = b[property] ? b[property] : "";
        let result = ar < br ? -1 : ar > br ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //查詢
    doQuery(selectKey) {
      let scope;
      if (selectKey) {
        if (selectKey != 'val') {
          this.selectKey = selectKey;
        }
        scope = "IDs";
        this.errors.clear("Dates");
      } else {
        scope = "Dates";
        this.errors.clear("IDs");
      }
      this.rtnList = [];
      this.$validator.validateAll(scope).then((el) => {
        if (!el) {
          let errMsg = [];
          this.errors.items.forEach((x) => errMsg.push(x.msg));
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach((s) => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }

        let reqData = {};
        if (!selectKey) {
          let startDate = ""; //查詢的起始日
          let endDate = ""; //查詢的結束日
          let lastDay = ""; //每月最後一天

          let startMonth =
            this.start_date[1].toString().length == 1
              ? "0" + this.start_date[1].toString()
              : this.start_date[1].toString();
          let endMonth =
            this.end_date[1].toString().length == 1
              ? "0" + this.end_date[1].toString()
              : this.end_date[1].toString();

          let start = this.start_date[0] + startMonth;
          let end = this.end_date[0] + endMonth;
          if (parseInt(start) > parseInt(end)) {
            this.setToastMsg("異動日期起始日不可大於結束日");
            return;
          }
          lastDay = new Date(
            this.end_date[0],
            parseInt(this.end_date[1]),
            0
          ).getDate();
          startDate = `${this.start_date[0]}-${startMonth}-01`;
          endDate = `${this.end_date[0]}-${endMonth}-${lastDay}`;

          reqData = {
            start_month: startDate,
            end_month: endDate,
          };
        } else {
          reqData[this.selectKey] = this.selectVal;
        }
        reqData.searchType = this.searchType;
        this.$validator.reset();
        this.mxMaskOpen = true;

        queryCustDataViewPermission(this.UserInfo.id, reqData).then(
          (result) => {
            this.mxMaskOpen = false;
            if (result.header && result.header.status == "200") {
              this.rtnList = result.body.result;
              this.registerHanlink(); // 難字顯示
            } else {
              this.$toast.info({ title: result.header.message });
            }
          }
        );

        if (this.editMode) {
          this.editMode = false;
          this.$toast.info({ title: "客戶資料檢視權限解除成功" });
        }
      });
    },
    //編輯資料
    doEdit(item) {
      this.editData = item;
      this.editMode = true;
    },
    doCancelEdit() {
      this.editMode = false;
      this.registerHanlink(); // 難字顯示
    },
    //解除紀錄預覽
    doPreview(item) {
      this.editData = item;
      this.modalOpen = true;
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    },
  },
  watch: {
    searchType() {
      this.rtnList = [];
    },
  },
  mounted() {
    let start = window.moment().year();
    for (let s = start - 2; s <= start + 2; s++) {
      this.yearOpt.push(s);
    }
    this.initColWidth();
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
</style>
